import { Component, OnInit, OnDestroy } from '@angular/core';
import { Params, ActivatedRoute, Router } from '@angular/router';
import { UntypedFormGroup, UntypedFormControl, Validators, FormArray } from '@angular/forms';
import { Subscription } from 'rxjs';

import { AppConstants } from 'appshared/app-constants';
import { AccessControl } from 'appshared/access-control';
import * as Models from 'appshared/shared-models';
import { MiscTools } from 'appshared/misc-tools';
import { ValidationTools } from 'appshared/validation-tools';
import { TextTools } from 'appshared/text-tools';

import { UsersService } from '../users.service';
import { AuthService } from 'client/app/services/auth.service';
import { OrganizationsService } from '../../organizations/organizations.service';
import { UiAlertsService } from 'client/app/components/ui-alerts/ui-alerts.service';

@Component({
	selector: 'app-user-access-form',
	templateUrl: './user-access-form.component.html',
	styleUrls: ['./user-access-form.component.scss']
})
export class UserAccessFormComponent implements OnInit, OnDestroy {
	ac = AppConstants;
	acl = AccessControl;

	// 'standard' edit stuff
	id: number;
	user: Models.User;
	organization: Models.Organization;

	tags: string[] = [];

	errors: string[] = [];
	theForm: UntypedFormGroup;
	loading = true;
	saving = false;

	// other stuff
	private userSubscription: Subscription;
	authUser: Models.AuthUser;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private uiAlertsService: UiAlertsService,
		private usersService: UsersService,
		private organizationsService: OrganizationsService,
		private authService: AuthService
	) {
		this.route.paramMap.subscribe((params) => {
			this.id = +params.get('id');
			if (this.id && this.id !== 0) {
				this.user = this.usersService.getOne(this.id);
				if (this.user && this.user.org_id && this.user.org_id !== 0)
					this.organization = this.organizationsService.getOne(this.user.org_id);
			}
			if (!this.user || this.user == null || this.user.id === 0) {
				this.router.navigate([AppConstants.urls.notfound]);
			}

			// this.tags = Object.keys(AppConstants.accessControlTags);

			this.loading = false;
		});
	}

	ngOnInit(): void {
		this.userSubscription = this.authService.user.subscribe((authUser) => {
			if (!authUser
				|| !ValidationTools.checkRole(this.user.role, AppConstants.staffUserRole)
				|| !ValidationTools.checkRole(authUser.role, AppConstants.adminUserRole))
				this.onCancel();


			this.initForm();
		});
	}

	ngOnDestroy() {
		if (this.userSubscription) this.userSubscription.unsubscribe();
	}

	initForm() {
		// using form control names that match object's property names makes
		// saving easier down the line...
		this.theForm = new UntypedFormGroup({
		});

		for (const accessControlTagGrouping of AccessControl.accessControlTagGroupings) {
			for (const tag of accessControlTagGrouping.tags) {
				const checked = this.user.directAccessTags.includes(tag);
				this.theForm.addControl(tag, new UntypedFormControl(checked));
			}
		}
	}

	async onSubmit() {
		this.saving = true;
		this.errors = [];

		const userTags = [];
		for (const accessControlTagGrouping of AccessControl.accessControlTagGroupings)
			for (const tag of accessControlTagGrouping.tags)
				if (this.theForm.value[tag]) userTags.push(tag);

		// console.log(userTags);

		try {
			const retUser = await this.usersService.setAccessTags(this.id, userTags);
			if (retUser) {
				this.router.navigate([AppConstants.urls.users + '/' + retUser.id]);
				this.saving = false;
			} else {
				this.saving = false;
				this.uiAlertsService.addMsg('Something went wrong,', 'danger', '', false, AppConstants.standardMessageAutoCloseTimeSecs);
			}
		} catch (e: any) {
			this.saving = false;
			this.uiAlertsService.addMsg(e.message, 'danger', '', false, AppConstants.standardMessageAutoCloseTimeSecs);
		}
	}

	onCancel() {
		this.router.navigate(['/' + AppConstants.urls.users, this.id], { relativeTo: this.route });
	}

	isChecked(tag: string) {
		return this.theForm.value[tag];
	}

}
